import { useEffect, useState } from 'react';
import { getConfig } from '../utils/get-config';

export function useApplePaySupport() {
  const [supportsApplePay, setSupportsApplePay] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    try {
      if (getConfig('REACT_APP_SHOW_WALLETS') == 'true') {
        setSupportsApplePay(true);
        return;
      }
      const w = window as any;
      if (
        w.ApplePaySession &&
        typeof w.ApplePaySession.canMakePayments === 'function'
      ) {
        const can = w.ApplePaySession.canMakePayments();
        setSupportsApplePay(!!can);
      } else {
        setSupportsApplePay(false);
      }
    } catch (e) {
      console.error('[ApplePay] erro na detecção:', e);
      setSupportsApplePay(false);
    } finally {
      setChecked(true);
    }
  }, []);

  return { supportsApplePay, checked };
}
